import React, { Suspense } from 'react';
import { Admin, CustomRoutes } from 'react-admin';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import dataProvider from './providers/dataProvider.ts';
import i18nProvider from './providers/i18nProvider.ts';
import Home from './pages/Home.tsx';
import NewsList from './pages/NewsList.tsx';
import { CustomLayout } from './components/menu/AppBar.tsx';
import { ThemeProvider } from '@mui/material/styles';
import { lightTheme, darkTheme } from './components/themes/main_theme.js';
import AboutUs from './pages/AboutUs.tsx';
import Donate from './pages/Donate.tsx';
import ContactUs from './pages/ContactUs.tsx';
import Ministries from './pages/Ministries.tsx';
import Gallery from './pages/Gallery.tsx';
import { BlogList, BlogPost } from './pages/Blog.tsx';

// Lazy-load the admin panel so it is code-split from the public bundle
const AdminApp = React.lazy(() => import('./admin/AdminApp.tsx'));

/** Public-facing site wrapped in React Admin for its layout / theming */
const PublicSite = () => (
  <ThemeProvider theme={lightTheme}>
    <Admin
      title="Salt and Light Ministries"
      dataProvider={dataProvider}
      defaultTheme="light"
      i18nProvider={i18nProvider}
      lightTheme={lightTheme}
      disableTelemetry
      darkTheme={darkTheme}
      layout={CustomLayout}
      theme={lightTheme}
      dashboard={Home}
    >
      <CustomRoutes>
        <Route path="/home" element={<Home />} />
        <Route path="/about_us" element={<AboutUs />} />
        <Route path="/news" element={<NewsList />} />
        <Route path="/ministries" element={<Ministries />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/contact_us" element={<ContactUs />} />
      </CustomRoutes>
    </Admin>
  </ThemeProvider>
);

const App = () => (
  <BrowserRouter>
    <Routes>
      {/* Admin CMS — lazy-loaded, protected by Cognito login */}
      <Route
        path="/admin/*"
        element={
          <Suspense fallback={<div style={{ padding: 32 }}>Loading admin…</div>}>
            <AdminApp />
          </Suspense>
        }
      />
      {/* Public ministry site */}
      <Route path="/*" element={<PublicSite />} />
    </Routes>
  </BrowserRouter>
);

export default App;